import {
  listAvailabilityTimeSlots as publicListAvailabilityTimeSlots,
  getAvailabilityTimeSlot as publicGetAvailabilityTimeSlot,
} from './bookings-availability-v2-time-slot-availability-time-slots.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listAvailabilityTimeSlots: MaybeContext<
  BuildRESTFunction<typeof publicListAvailabilityTimeSlots> &
    typeof publicListAvailabilityTimeSlots
> = /*#__PURE__*/ createRESTModule(publicListAvailabilityTimeSlots);
export const getAvailabilityTimeSlot: MaybeContext<
  BuildRESTFunction<typeof publicGetAvailabilityTimeSlot> &
    typeof publicGetAvailabilityTimeSlot
> = /*#__PURE__*/ createRESTModule(publicGetAvailabilityTimeSlot);

export { LocationType } from './bookings-availability-v2-time-slot-availability-time-slots.universal.js';
export {
  TimeSlot,
  Location,
  EventInfo,
  WaitingList,
  BookingPolicyViolations,
  AvailableResources,
  Resource,
  NestedTimeSlot,
  NonBookableReasons,
  ListAvailabilityTimeSlotsRequest,
  CursorPaging,
  CustomerChoices,
  ResourceType,
  ListAvailabilityTimeSlotsResponse,
  CursorPagingMetadata,
  Cursors,
  GetAvailabilityTimeSlotRequest,
  GetAvailabilityTimeSlotRequestCustomerChoices,
  GetAvailabilityTimeSlotResponse,
  ListMultiServiceAvailabilityTimeSlotsRequest,
  Service,
  V2CustomerChoices,
  ListMultiServiceAvailabilityTimeSlotsResponse,
  GetMultiServiceAvailabilityTimeSlotRequest,
  GetMultiServiceAvailabilityTimeSlotResponse,
  ListEventTimeSlotsRequest,
  ListEventTimeSlotsResponse,
  GetEventTimeSlotRequest,
  GetEventTimeSlotResponse,
  ListAvailabilityTimeSlotsOptions,
  GetAvailabilityTimeSlotOptions,
} from './bookings-availability-v2-time-slot-availability-time-slots.universal.js';
export {
  LocationTypeWithLiterals,
  ListAvailabilityTimeSlotsApplicationErrors,
  GetAvailabilityTimeSlotApplicationErrors,
} from './bookings-availability-v2-time-slot-availability-time-slots.universal.js';
